import UserActionTypes from "./user.types";

export const setCurrentUser = (user) => ({
  type: UserActionTypes.SET_CURRENT_USER,
  payload: user,
});

export const googleSignInStart = () => ({
  type: UserActionTypes.GOOGLE_SIGN_IN_START,
});
export const emailSignInStart = (emailAndPassword) => ({
  type: UserActionTypes.EMAIL_SIGN_IN_START,
  payload: emailAndPassword,
});

export const signInSuccess = (user) => ({
  type: UserActionTypes.SIGN_IN_SUCCESS,
  payload: user,
});

export const signInFailure = (error) => ({
  type: UserActionTypes.SIGN_IN_FAILURE,
  payload: error,
});

export const checkUserSession = () => ({
  type: UserActionTypes.CHECK_USER_SESSION,
});

export const signOutStart = (callback) => ({
  type: UserActionTypes.SIGN_OUT_START,
  payload: callback,
});

export const signOutSuccess = () => ({
  type: UserActionTypes.SIGN_OUT_SUCCESS,
});

export const signOutFailure = (error) => ({
  type: UserActionTypes.SIGN_OUT_FAILURE,
  payload: error,
});

export const registerNewErntehelfer = (userData) => ({
  type: UserActionTypes.INVITE_USER,
  payload: userData,
});

export const inviteUserFailure = (error) => ({
  type: UserActionTypes.INVITE_USER_FAILURE,
  payload: error,
});

export const inviteUserSuccess = () => ({
  type: UserActionTypes.INVITE_USER_SUCCESS,
});

export const fetchUsersStart = () => ({
  type: UserActionTypes.FETCH_USERS_START,
});

export const fetchUsersSuccess = (userItems) => ({
  type: UserActionTypes.FETCH_USERS_SUCCESS,
  payload: userItems,
});

export const fetchUsersFailure = (error) => ({
  type: UserActionTypes.FETCH_USERS_FAILURE,
  payload: error,
});
